// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material'
import { FC, useContext, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
// others block
import { CaseStatus } from '../../../generated'
import { PrimaryDots } from '../../assets/images'
import { AppContext, AuthContext, CaseContext } from '../../context'
import { ActionType } from '../../context/AppContextReducer'
import { CasesMenuProps } from '../../interfaceTypes'
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants'
import { CaseActionType } from '../cases/caseReducer'
import { getDuplicateCasePath } from '../../utils/caseFormValues'

export const CasesMenu: FC<CasesMenuProps> = ({ currentCase }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false)
  const { dispatch, isDeleteOpen, isEdit, isDeleteCaseOpen } = useContext(AppContext)
  const { isInvestigator, isSuperAdmin, isAdmin, isAccountant, isParalegal, isAttorney } = useContext(AuthContext)
  const { dispatch: caseDispatch } = useContext(CaseContext)
  const { id, status, isConsultMatter } = currentCase || {}
  const caseId = id || ''

  const handleClick = () => setOpen(!open)

  const handleClose = () => setOpen(false)

  const anchorRef = {
    [caseId]: useRef<HTMLButtonElement>(null)
  }

  const handleDeleteModal = () => {
    handleClose()
    dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
    caseDispatch({ type: CaseActionType.SET_CURRENT_CASE, currentCase: currentCase })
  }

  const handleArchiveModal = () => {
    handleClose()
    dispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
    caseDispatch({ type: CaseActionType.SET_CURRENT_CASE, currentCase: currentCase })
  }

  const handleDeleteCaseModal = () => {
    handleClose()
    dispatch({ type: ActionType.SET_IS_DELETE_CASE_OPEN, isDeleteCaseOpen: !isDeleteCaseOpen })
    caseDispatch({ type: CaseActionType.SET_CURRENT_CASE, currentCase: currentCase })
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[caseId]}
        id={`long-button-${caseId}`}
        aria-controls={`long-menu-${caseId}`}
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="show more"
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${caseId}`}
        anchorEl={anchorRef[caseId].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem component={Link} to={`/matters/matter-detail/${caseId}`}>
          View
        </MenuItem>

        {/* Same roles as the Duplicate button on Matter Detail. */}
        {(isParalegal || isAttorney || isAdmin) && (
          <MenuItem component={Link} to={getDuplicateCasePath(caseId, isConsultMatter)}>
            Duplicate
          </MenuItem>
        )}

        {status !== CaseStatus.Completed && !isInvestigator && (
          <MenuItem onClick={handleDeleteModal} sx={{ color: 'green' }}>
            Close Matter
          </MenuItem>
        )}

        {status === CaseStatus.Completed && (isAdmin || isAccountant) && (
          <MenuItem onClick={handleDeleteModal} sx={{ color: 'green' }}>
            Open Matter
          </MenuItem>
        )}

        {status !== CaseStatus.Completed && isSuperAdmin && (
          <MenuItem onClick={handleArchiveModal} sx={{ color: 'primary.main' }}>
            Archive Matter
          </MenuItem>
        )}

        {(isSuperAdmin || isAdmin) && (
          <MenuItem onClick={handleDeleteCaseModal} sx={{ color: 'primary.main' }}>
            Delete Matter
          </MenuItem>
        )}
      </Menu>
    </Box>
  )
}
